/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Export_Preset_Name_RequiredInputs */

const en_video_export_export_preset_name_required = /** @type {(inputs: Video_Export_Export_Preset_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter a preset name`)
};

const fr_video_export_export_preset_name_required = /** @type {(inputs: Video_Export_Export_Preset_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez saisir un nom de prereglage`)
};

const de_video_export_export_preset_name_required = /** @type {(inputs: Video_Export_Export_Preset_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte geben Sie einen voreingestellten Namen ein.`)
};

const it_video_export_export_preset_name_required = /** @type {(inputs: Video_Export_Export_Preset_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci un nome predefinito`)
};

const ru_video_export_export_preset_name_required = /** @type {(inputs: Video_Export_Export_Preset_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, введите предустановленное имя.`)
};

const es_video_export_export_preset_name_required = /** @type {(inputs: Video_Export_Export_Preset_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, introduzca un nombre preestablecido`)
};

const zh_cn2_video_export_export_preset_name_required = /** @type {(inputs: Video_Export_Export_Preset_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入预设名称`)
};

const ja_video_export_export_preset_name_required = /** @type {(inputs: Video_Export_Export_Preset_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセット名を入力してください`)
};

const hi_video_export_export_preset_name_required = /** @type {(inputs: Video_Export_Export_Preset_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया एक पूर्व निर्धारित नाम दर्ज करें`)
};

const pt_pt2_video_export_export_preset_name_required = /** @type {(inputs: Video_Export_Export_Preset_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, insira um nome predefinido.`)
};

/**
* | output |
* | --- |
* | "Please enter a preset name" |
*
* @param {Video_Export_Export_Preset_Name_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_export_preset_name_required = /** @type {((inputs?: Video_Export_Export_Preset_Name_RequiredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Export_Preset_Name_RequiredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_export_preset_name_required(inputs)
	if (locale === "de") return de_video_export_export_preset_name_required(inputs)
	if (locale === "it") return it_video_export_export_preset_name_required(inputs)
	if (locale === "ru") return ru_video_export_export_preset_name_required(inputs)
	if (locale === "es") return es_video_export_export_preset_name_required(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_export_preset_name_required(inputs)
	if (locale === "ja") return ja_video_export_export_preset_name_required(inputs)
	if (locale === "hi") return hi_video_export_export_preset_name_required(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_export_preset_name_required(inputs)
	return en_video_export_export_preset_name_required(inputs)
});